"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { hrVerification } from "@/content/agent-use-cases/hr-verification";

export default function HrVerificationUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={hrVerification} locale={locale} />;
}
